// no-react-compiler
import { runOnJS, useSharedValue, withTiming } from "react-native-reanimated";
import { useEffect, useMemo, useCallback } from "react";
import { useWindowDimensions, ViewProps } from "react-native";
import { useNonReactiveCallback } from "@/src/common/useNonReactiveCallback";

export function useBackdrop(
  duration: { open: number; close: number } = {
    open: 380,
    close: 340,
  },
  onStart?: () => void
) {
  "use no memo";
  const dimensions = useWindowDimensions();
  const containerStyle = useMemo(
    () =>
      ({
        position: "absolute",
        left: 0,
        top: 0,
        width: dimensions.width,
        height: dimensions.height,
      }) as ViewProps["style"],
    [dimensions.height, dimensions.width]
  );
  const animation = useSharedValue(0);

  const runOnStart = useNonReactiveCallback(() => {
    onStart?.();
  });

  useEffect(() => {
    animation.value = withTiming(1, { duration: duration.open });
    setTimeout(() => {
      runOnStart();
    }, 30);
  }, [animation, duration.open, runOnStart]);
  const close = useCallback(
    (onClosed: () => void) => {
      animation.set(
        withTiming(0, { duration: duration.close }, () => {
          runOnJS(onClosed)();
        })
      );
    },
    [animation, duration.close]
  );
  return { animation, close, containerStyle } as const;
}
